import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" />
      <div className="container-page py-24 text-center">
        <div className="font-display text-7xl font-bold text-brand-300">404</div>
        <h1 className="mt-4 font-display text-3xl font-bold">Page not found</h1>
        <p className="mt-2 text-slate-600">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-6 inline-flex">Back home</Link>
      </div>
    </>
  );
}
